import { useParams } from 'react-router-dom';
import PageScaffold from '../../components/PageScaffold';
import { DOMAINS_PAGE_PATH } from './DomainsPage';
import { useContext, useEffect } from 'react';
import DomainsContext from '../../contexts/data/DomainsContext';
import { ContextStatus } from '@leedpulse-monorepo/enums';
import { Card } from 'antd';
import { DomainCreationFormProvider } from '../../contexts/forms/domains/DomainCreationFormContext';
import { DomainEditionFormProvider } from '../../contexts/forms/domains/DomainEditionFormContext';
import DomainDetails from '../../components/domains_page/DomainDetails';
import DomainCreationForm from '../../components/domains_page/DomainCreationForm';
import { useNavigate } from 'react-router-dom';

interface DomainDetailPageProps {
  isCreateMode: boolean;
}

const DomainDetailPage: React.FC<DomainDetailPageProps> = ({
  isCreateMode,
}) => {
  const domainsContext = useContext(DomainsContext);
  const navigate = useNavigate();

  const { domainId } = useParams<{ domainId: string }>();

  const selectionMismatch =
    (!isCreateMode && domainsContext.selected === null) ||
    (!isCreateMode && domainsContext.selected?.id !== (domainId));

  useEffect(() => {
    if (
      selectionMismatch &&
      domainsContext.selectionStatus !== ContextStatus.LOADING && 
      domainId
    ) {
      domainsContext.fetchAndSelectById(domainId);
    }
    return () => {
      domainsContext.reset();
    };
  }, []);

  if (!domainId && !isCreateMode) {
    navigate(DOMAINS_PAGE_PATH);
    return;
  }

  return (
    <PageScaffold
      title={isCreateMode ? 'Nouveau domaine' : (domainsContext.selected?.name || '')}
      subtitle={
        isCreateMode
          ? 'Ajoutez un nouveau domaine'
          : 'Consultez et modifiez les informations du domaine'
      }
      breadcrumbItems={[
        {
          target: DOMAINS_PAGE_PATH,
          title: 'Domaines',
        },
        {
          title: isCreateMode ? 'Nouveau' : domainsContext.selected?.name || '',
        },
      ]}
    >
      {isCreateMode ? (
        <DomainCreationFormProvider>
          <DomainCreationForm />
        </DomainCreationFormProvider>
      ) : selectionMismatch || domainsContext.selected == null ? (
        <Card loading />
      ) : (
        <DomainEditionFormProvider>
          <DomainDetails domain={domainsContext.selected} />
        </DomainEditionFormProvider>
      )}
    </PageScaffold>
  );
};

export default DomainDetailPage;
